import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutAgencyLookup extends Layout {
    sourceAgency: DataSource;
    tableAgency: Table;
}
